import AWS from './aws-config.js';
import { normalizeString } from "./index";
export default class UploadFile {
  constructor(clientId, clientName, user) {
    this.clientId = clientId;
    this.user = user;
    this.clientName = clientName;
    this.isSetAccelerateConfiguration = false;

    switch (process.env.REACT_APP_BUNKEY_ENV) {
      case "production":
        this.bucket = "bunkey-prod";
        break;
      case "qa":
        this.bucket = "bunkey-qa";
        break;
      default:
        this.bucket = "bunkey-develop";
        break;
    }
    //esto se ṕodra mandar al env?
    
    AWS.config.setPromisesDependency();
  }

  checkIsSetAccelerateConfiguration() {
    const s3 = new AWS.S3({ region: "us-east-2" });
    return new Promise((resolve, reject) => {
      // Try to get acceleration configuration, but handle permission errors gracefully
      s3.getBucketAccelerateConfiguration(
        { Bucket: this.bucket },
        (err, resp) => {
          if (err) {
            // If we get an AccessDenied error, we don't have permission to check/set acceleration
            // Just proceed without acceleration rather than failing the upload
            if (err.code === 'AccessDenied') {
              console.warn('No permission to check/set S3 acceleration. Proceeding without acceleration:', err.message);
              this.isSetAccelerateConfiguration = true; // Proceed without acceleration
              resolve();
              return;
            }
            // For other errors, we might want to still reject
            console.error('Error checking S3 acceleration configuration:', err);
            this.isSetAccelerateConfiguration = true; // Still proceed with upload
            resolve();
            return;
          }
          
          if (resp && resp.Status !== "Enabled") {
            // Try to enable acceleration, but be prepared for permission issues
            s3.putBucketAccelerateConfiguration(
              {
                AccelerateConfiguration: {
                  Status: "Enabled"
                },
                Bucket: this.bucket
              },
              (err, data) => {
                if (err) {
                  // If we can't set acceleration, just proceed without it
                  console.warn('Could not enable S3 acceleration. Proceeding without acceleration:', err.message);
                  this.isSetAccelerateConfiguration = true; // Still proceed with upload
                  resolve();
                } else {
                  this.isSetAccelerateConfiguration = true;
                  resolve();
                }
              }
            );
          } else {
            this.isSetAccelerateConfiguration = true;
            resolve();
          }
        }
      );
    });
  }

  /**
   * @param {Object} options
   *   - keyPrefix: carpeta dentro del cliente. Por defecto el archivo cae en
   *     `<clientId>/<s3Name>`, que es donde viven los assets.
   *   - publicRead: si false, NO se aplica la ACL public-read del final. Se usa
   *     para el contrato de derechos de uso (DES-196): es un documento legal y
   *     se entrega sólo por URL firmada desde el backend. El default queda en
   *     true para no cambiar el comportamiento de los otros llamadores.
   */
  async startUpload(
    file,
    setUploadObjectAction,
    onProgressUploadAction,
    onSuccessAction,
    onErrorAction,
    noStopUploadErrorAction,
    options = {}
  ) {
    const { keyPrefix = "", publicRead = true } = options;
    // We'll always proceed with upload, even if acceleration couldn't be configured
    // The checkIsSetAccelerateConfiguration method now sets this to true even on permission errors

    const fileKey = `${this.clientId}/${keyPrefix}${file.s3Name}`;
    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: this.bucket,
        Key: fileKey,
        Body: file.file
      },
      partSize: 5 * 1024 * 1024,
      queueSize: 1,
      tags: [
        { Key: "Content-Disposition", Value: "attachment" },
        { Key: "Content-Type", Value: file.type },
        { Key: "x-amz-meta-uuid", Value: file.uuid },
        { Key: "ext", Value: file.ext },
        { Key: "size", Value: file.size },
        { Key: "name", Value: normalizeString(file.name) },
        { Key: "user-name", Value: normalizeString(this.user.name) },
        { Key: "client-name", Value: normalizeString(this.clientName) },
        { Key: "applyRkg", Value: file.applyRkg }
      ]
    });
    // REDUX  ESTO ES PARA SETEAR EL ARCHIVO QUE SE VA A SUBIR
    //  BUSCA EL ARCHIVO POR data.file.uuid Y LE SETEA uploadObject
    // this.props.setUploadObjectToFileVersionAsset(data, upload)
    if (setUploadObjectAction) {
      setUploadObjectAction(file, upload);
    }

    upload
      .on("httpUploadProgress", e => {
        //REDUX esta es parair actualizando el progreso del archivo
        // this.props.updateFileProgressVersionAsset(e, data)
        if (onProgressUploadAction) {
          onProgressUploadAction(file, e);
        }
      })
      .promise()
      .then(
        respUpload => {
          // Sin ACL pública el objeto queda sólo accesible por credenciales o
          // por una URL firmada: es lo que corresponde para el contrato.
          if (!publicRead) {
            if (onSuccessAction) {
              onSuccessAction({
                ...file,
                key: respUpload.Key,
                futureFileURL: respUpload.Location
              });
            }
            return;
          }

          const s3 = new AWS.S3();
          // coloca el acceso publico alasset
          // localtion : es
          s3.putObjectAcl(
            {
              Bucket: this.bucket,
              Key: respUpload.Key,
              ACL: "public-read"
            },
            (err, respAcl) => {
              if (err) console.log(err, err.stack);
              else {
                if (onSuccessAction) {
                  onSuccessAction({
                    ...file,
                    key: respUpload.Key,
                    futureFileURL: respUpload.Location
                  });
                }
              }
            }
          );
        },
        err => {
          if (onErrorAction) {
            onErrorAction(file);
          }

          if (err.code !== "RequestAbortedError" && noStopUploadErrorAction) {
            noStopUploadErrorAction();
          }
        }
      );
  }
}
